import { useEffect, useRef } from "react";

//setInterval doesn't work well with useEffect. It doesn't receive updated state information, so the recentActivity was always it's intial value
//  useInterval fixes that issue by recreating the callback whenever the Autologout component remounts
//https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export function useInterval(callback: Function, delay: number) {
  const savedCallback = useRef((() => { }) as Function); 

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}